import React, { useMemo, useState } from "react";
import { getTurnoverBarColor, formatPercent } from "./utils";

function TurnoverSection({ turnover }) {
  const [activeTooltip, setActiveTooltip] = useState(null);
  const { summary, items } = turnover;

  const turnoverMax = useMemo(() => {
    const maxValue = Math.max(
      ...items.map((item) => item.turnoverPercent || 0),
      summary.turnoverPercent || 0,
      8,
    );
    return Math.ceil(maxValue / 4) * 4;
  }, [items, summary.turnoverPercent]);

  const axisTicks = useMemo(() => {
    const step = turnoverMax / 4;
    return [0, 1, 2, 3, 4].map((index) => Math.round(step * index));
  }, [turnoverMax]);

  return (
    <section className="hr-dashboard__card">
      <h2 className="hr-dashboard__section-title">Текучесть персонала</h2>

      <div className="hr-dashboard__split">
        <div className="hr-dashboard__chart-panel">
          {items.length === 0 ? (
            <p className="hr-dashboard__empty-state">Нет данных по текучести</p>
          ) : (
            <>
              <div className="hr-dashboard__turnover-chart">
                {items.map((item) => (
                  <div key={item.id ?? item.code} className="hr-dashboard__bar-row">
                    <div className="hr-dashboard__bar-label">
                      {item.name || item.code}
                    </div>
                    <div
                      className="hr-dashboard__bar-track"
                      onMouseEnter={() => setActiveTooltip(item.code)}
                      onMouseLeave={() => setActiveTooltip(null)}
                    >
                      <div
                        className="hr-dashboard__bar-fill"
                        style={{
                          width: `${((item.turnoverPercent || 0) / turnoverMax) * 100}%`,
                          backgroundColor: getTurnoverBarColor(item.status),
                        }}
                      />
                      {activeTooltip === item.code && (
                        <div className="hr-dashboard__tooltip">
                          <strong>{item.code}</strong>
                          <span>Уволено: {item.resigned}</span>
                          <span>
                            Текучесть: {formatPercent(item.turnoverPercent)}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div className="hr-dashboard__axis">
                {axisTicks.map((tick) => (
                  <span key={tick}>{tick}%</span>
                ))}
              </div>
            </>
          )}
        </div>

        <div className="hr-dashboard__table-wrap">
          <table className="hr-dashboard__table hr-dashboard__table--compact">
            <thead>
              <tr>
                <th>Отделение</th>
                <th>Уволено</th>
                <th>Текучесть</th>
                <th>Статус</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 ? (
                <tr>
                  <td colSpan={4} className="hr-dashboard__empty-value">
                    Нет данных
                  </td>
                </tr>
              ) : (
                items.map((item) => (
                  <tr key={item.id ?? item.code}>
                    <td>{item.code}</td>
                    <td>{item.resigned}</td>
                    <td>{formatPercent(item.turnoverPercent)}</td>
                    <td>
                      <span
                        className={`hr-dashboard__badge hr-dashboard__badge--${
                          item.status === "risk" ? "red" : "green"
                        }`}
                      >
                        {item.statusLabel}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}

export default TurnoverSection;
